import React from 'react';
import CardUI from '../../../widgets/layout/CardUI';
import SpinnerComponentUI from '../../common/SpinnerComponentUI';
import GenericErrorUI from '../../common/GenericErrorUI';
import { Link } from 'react-router-dom';
import AddChargeAmountModalSF from '../../../pages/superUser/loan/AddChargeAmountModalSF';
import AddChargeAmountUpdateModalSF from '../../../pages/superUser/loan/AddChargeAmountUpdateModalSF';
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF';
import './LoanDetail.css';
import ButtonUI from '../../../widgets/action/ButtonUI';
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI';

const OutOfPocketExpenseUI = ({ context, loan, title, chargeType, outOfPocketExpenses, grandTotals,
  onAddChargesClick, onDocDownloadClick, onFileDeleteClick,
  onLegalInvoiceUpdateClick, onUploadClick
}) =>
  <CardUI className='g_m_bottom_100 su_loan'>
    <div className='g_flex_h'>
      <span><b>{title}</b></span>
      {
        chargeType === "oop_expense" &&
        <Link onClick={onAddChargesClick} to='#'>Add charges</Link>
      }
    </div>

    <hr style={{ color: 'gray' }} />
    {outOfPocketExpenses && outOfPocketExpenses.length > 0 && (
      outOfPocketExpenses.map((charge, index) => (
        <div key={index} className="g_m_bottom_20">
          <div>
            <span className='g_flex_v'>
              <div className='g_flex_h g_flex_between'>
                <span>Amount: {charge.amountF1}</span>
                <div>
                  {
                    chargeType === "oop_expense" &&
                    <ButtonTinyUI label='Edit'
                      data-charge-create-id={charge.dateCreated} onClick={(event) => onLegalInvoiceUpdateClick(event, charge)}
                      data-invoice-number={charge.invoiceId}
                      date-created={charge.dateCreated}
                    />
                  }
                </div>
              </div>
              {charge.formula && (
                <span className='g_muted g_small'>Formula: {charge.formula}</span>
              )}
              {
                chargeType === "oop_expense" &&
                <div className='g_flex_v'>
                  {
                    charge.invoiceDateF1 && charge.invoiceDateF1 !== "" &&
                    <span className='g_muted'>Invoice date: {charge.invoiceDateF1}</span>
                  }
                  <span className='g_muted'>Due date: {charge.dueDateF1}</span>
                </div>
              }
              {
                chargeType === "interest_on_overdue_oop_exp" &&
                <span className='g_muted'>
                  <span>Start Date: {charge.chargeStartDateF1}</span>
                  <span>End Date: {charge.chargeEndDateF1}</span>
                </span>
              }
            </span>
          </div>

          {charge.remarks && (
            <div className='g_small g_muted'>
              Remarks: {charge.remarks}
            </div>
          )}
          {
            chargeType === "oop_expense" && charge.invoiceNumber && charge.invoiceNumber !== "" &&
            <div className='g_flex_h g_flex_left g_m_top_10'>
              <Link
                className='g_m_right_50'
                onClick={onDocDownloadClick}
                to='#'
                data-loan-id={loan.loanId}
                data-file-name={charge.invoiceFileUrl}
                data-invoice-number={charge.invoiceId}
              >
                {charge.invoiceFileUrl}
              </Link>
              <div>
                {charge.invoiceFileUrl !== "" &&
                  <span
                    className='icon icon-trash-o g_m_left_30 g_m_right_50'
                    onClick={onFileDeleteClick}
                    data-invoice-number={charge.invoiceId}
                    data-file-name={charge.invoiceFileUrl}
                  />
                }
              </div>
            </div>
          }
          {
            charge.invoiceFileUrl === "" && chargeType === "oop_expense" && 
            <ButtonTinyUI
              label="Upload Invoice"
              className='g_m_left_30 g_m_right_50'
              onClick={onUploadClick}
              data-invoice-number={charge.invoiceId}
            />
          }

          {charge.paymentList && charge.paymentList.length > 0 && (
            <div className='g_m_top_10'>
              <h4 className='g_flex_h'>Payment History</h4>
              <table className='table td th'>
                <thead>
                  <tr>
                    <th>Initiated Date</th>
                    <th>Amount Paid</th>
                    <th>Amount Paid from DSRA</th>
                    <th>Paid Date</th>
                  </tr>
                </thead>
                <tbody>
                  {charge.paymentList.map((payment, idx) => (
                    <tr key={idx}>
                      <td>{payment.initiatedDateF1}</td>
                      <td>{payment.amountF5}</td>
                      <td>{payment.amountPaidFromDSRAF5}</td>
                      <td>{payment.paidDateF1}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <hr className="g_m_top_20" style={{ color: 'lightgray' }} />
        </div>
      ))
    )}

    {outOfPocketExpenses && outOfPocketExpenses.length > 0 && (
      <div className="payment-summary-section">
        <div className="payment-summary-title">Payment Summary</div>
        <div className="payment-summary-row">
          <span className="payment-summary-label">Total Charges:</span>
          <span className="payment-summary-value">{grandTotals.totalChargesFormatted}</span>
        </div>
        <div className="payment-summary-row">
          <span className="payment-summary-label">Total Payments:</span>
          <span className="payment-summary-value">{grandTotals.totalPaidFormatted}</span>
        </div>
        <div className="payment-summary-total-row">
          <span>Remaining Balance:</span>
          <span className={`payment-summary-remaining ${grandTotals.totalRemaining > 0 ? 'payment-summary-remaining-positive' : 'payment-summary-remaining-zero'}`}>
            {grandTotals.totalRemainingFormatted}
          </span>
        </div>
      </div>
    )}
  </CardUI>

export default OutOfPocketExpenseUI;